var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMKafd = function SvgMKafd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 23
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.01 0v10.41L12.457 0h3.689L6.148 11.172 16.47 23h-3.688L3.009 11.951V23H0V0zM36.7 0l8.445 23H41.94l-1.847-5.159-1.025-2.858L35 3.628l-4.068 11.355-1.024 2.858L28.06 23h-3.204l8.446-23zm31.618 0v2.892h-10.03v7.458h9.61v2.891h-9.61V23h-3.01V0zm19.939 0q4.626 0 7.685 3.335Q98.999 6.67 99 11.5t-3.058 8.165T88.257 23h-8.834V0zm0 2.892h-5.825v17.217h5.825q3.461 0 5.663-2.465 2.2-2.463 2.2-6.144 0-3.679-2.2-6.144-2.202-2.464-5.663-2.464"
  })));
};
export default SvgMKafd;